var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGuardTurnedOn = function SvgGuardTurnedOn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 378,
    height: 378,
    viewBox: "0 0 378 378",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3956",
    fill: "currentColor",
    transform: "translate(-362.16 -365.45)scale(13.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3935",
    d: "M32.375 37A2.37 2.37 0 0 0 30 39.375v11.25A2.37 2.37 0 0 0 32.375 53h15.25A2.37 2.37 0 0 0 50 50.625v-11.25A2.37 2.37 0 0 0 47.625 37zM40 42a2 2 0 0 1 2 2 1.98 1.98 0 0 1-1 1.719V48.5h-2v-2.781A1.98 1.98 0 0 1 38 44a2 2 0 0 1 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3939",
    d: "M40 27c-3.866 0-7 2.686-7 6l-.02 4.034h3l.02-3.003C36.014 31.798 37.79 30 40 30s4 1.799 4 4.031l.02 3.036h3L47 33c-.016-3.314-3.134-6-7-6"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGuardTurnedOn);
export default ForwardRef;